import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-form-group-error-message',
  standalone: true,
  imports: [CommonModule],
  template:`
    <ng-container [ngSwitch]="getErrorType()">
      <small *ngSwitchCase="'required'" class="p-error block">Campo Requerido.</small>
      <small *ngSwitchCase="'pattern'" class="p-error block">El campo no cumple con las condiciones.</small>
      <small *ngSwitchCase="'email'" class="p-error block">Email no es válido.</small>
      <small *ngSwitchCase="'maxlength'" class="p-error block">
        El texto es demasiado largo. Máximo {{ control?.getError('maxlength')?.requiredLength }} caracteres.
      </small>
      <small *ngSwitchCase="'min'" class="p-error block">
        El valor debe ser al menos {{ control?.getError('min')?.min }}.
      </small>
    </ng-container>
  `
})
export class FormGroupErrorMessageComponent {
  @Input() control !: AbstractControl | null;

  getErrorType(): string | null {
    if (this.control?.errors) {
      return Object.keys(this.control.errors)[0];
    }
    return null;
  }
}
